import React from "react";
import { Box, alpha, useTheme } from "@mui/material";
import { AppTable } from "../../../../../components/AppTable";
import { createJournalColumns } from "../journalColumns";
import { JournalTableProps } from "../types";
import { IJournalEntryListItem } from "../../../accounting.interface";
import { useAuth } from "../../../../auth/hooks/useAuth";

export const JournalTable: React.FC<JournalTableProps> = ({
  data,
  pagination,
  onJournalClick,
  onReverseJournal,
  onDeleteJournal,
  onEditJournal,
  onPostJournal,
  onCopyJournalId,
}) => {
  const theme = useTheme();
  const { user } = useAuth();
  // Create wrapper functions to handle type conversion
  const columns = createJournalColumns({
    onJournalClick: (journal: any) =>
      onJournalClick(journal as IJournalEntryListItem),
    onReverseJournal: (journal: any) =>
      onReverseJournal(journal as IJournalEntryListItem),
    onDeleteJournal: (journal: any) =>
      onDeleteJournal(journal as IJournalEntryListItem),
    onEditJournal: (journal: any) =>
      onEditJournal(journal as IJournalEntryListItem),
    onPostJournal: (journal: any) =>
      onPostJournal(journal as IJournalEntryListItem),
    onCopyJournalId,
    user,
  });

  return (
    <Box
      sx={{
        borderRadius: 0.5,
        border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
        overflow: "hidden",
      }}
    >
      <AppTable
        data={data}
        columns={columns}
        pagination={{
          total: pagination.total,
          page: pagination.page,
          pageSize: pagination.pageSize,
          onPageChange: pagination.onPageChange,
          onPageSizeChange: pagination.onPageSizeChange,
        }}
        loading={false}
        emptyState={{
          icon: "receipt_long",
          title: "No Journal Entries Found",
          description:
            "No journal entries match your current filters. Try adjusting your search criteria or create a new journal entry.",
          actionLabel: "Create Journal Entry",
        }}
        styleOptions={{
          bordered: false,
          headerBackground: alpha(theme.palette.primary.main, 0.02),
        }}
      />
    </Box>
  );
};
